
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { addApolloState, initializeApollo, Seo_Swnz_SeoFragment, useGetPageCollectionBySlugQuery, } from 'content-service';
import { connectorElementQueries } from 'content-service/src/helpers/connectorElementQueries';
import { enquiryFormFieldsQuery, finderResultsContentQuery, footerQuery, swnzHeaderQuery, swnzSiteSearchQuery, swnzTopNavQuery, } from 'content-service/src/helpers/serversideQueries';
import { GetStaticProps } from 'next';
import ProviderFinderResults from 'src/components/Search/ProviderFinderResults';
import { CONTENT_SERVICE } from 'src/constants';
import { useTrackPageViews } from 'tracking';
import { Error, PageSeo } from 'ui';
import { getQueryLocale } from 'utils';
import { buildPageQueryInput } from 'utils/src/helpers/slug';
import { SLUG } from '../../../constants';
import ResultsPage from '../../../templates/ResultsPage';
interface ProviderFinderResultsPageProps {
    slug: string;
    preview: boolean;
    pageError: boolean;
    locale: string;
    pageSeo: Seo_Swnz_SeoFragment;
}
const ProviderFinderResultsPage = ({ slug, preview, locale, pageSeo, }: ProviderFinderResultsPageProps) => {
    const pageQueryInput = buildPageQueryInput(slug);
    const { data, error } = useGetPageCollectionBySlugQuery({
        variables: { ...pageQueryInput, preview, locale }
    });
    const [page] = data?.swnz_pageCollection?.items || [];
    useTrackPageViews({ pageName: pageSeo?.title ?? '' });
    if (error || !slug || !page || page?.slug !== slug) {
        return <Error preview={preview} title={slug} statusCode={404}/>;
    }
    return (<>
      <PageSeo pageSeo={pageSeo}/>
      <ResultsPage page={page}>
        <ProviderFinderResults />
      </ResultsPage>
    </>);
};
const getStaticProps: GetStaticProps = async ({ preview = false, locale, defaultLocale, }) => {
    const slug = SLUG.SEARCH_RESULTS_PAGE_SLUG.PROVIDER;
    const apolloClient = initializeApollo({ preview: preview });
    let pageSeo: Seo_Swnz_SeoFragment | null = null;
    const queryLocale = getQueryLocale(locale, defaultLocale);
    let showLcf = true;
    try {
        const [pageContentQueryResponse, ...rest] = await Promise.allSettled([
            finderResultsContentQuery({ apolloClient, slug, preview, locale: queryLocale }),
            swnzHeaderQuery({
                apolloClient,
                preview,
                codeId: CONTENT_SERVICE.HEADER_CODE_ID,
                locale: queryLocale
            }),
            swnzTopNavQuery({
                apolloClient,
                codeId: CONTENT_SERVICE.SECONDARY_TOP_NAV,
                preview,
                locale: queryLocale
            }),
            swnzTopNavQuery({
                apolloClient,
                codeId: CONTENT_SERVICE.SECONDARY_TOP_NAV_LOGGED_IN,
                preview,
                locale: queryLocale
            }),
            footerQuery({ apolloClient, preview, locale: queryLocale }),
            enquiryFormFieldsQuery({ apolloClient, preview, locale: queryLocale }),
            swnzSiteSearchQuery({
                apolloClient,
                codeId: CONTENT_SERVICE.QUICK_LINKS,
                preview,
                locale: queryLocale
            }),
        ]);
        rest.filter((queryResponse) => {
            if (queryResponse.status !== 'fulfilled')
                console.error(`⚠️  Error in query response for page: ${slug}`);
        });
        if (pageContentQueryResponse.status === 'fulfilled') {
            pageSeo = pageContentQueryResponse.value.pageSeo ?? null;
            if (pageContentQueryResponse?.value?.showLcf === false) {
                showLcf = false;
            }
            await connectorElementQueries(apolloClient, pageContentQueryResponse.value.elementData, queryLocale);
        }
        return addApolloState(apolloClient, {
            props: { slug, preview, locale: queryLocale, pageSeo, showLcf }
        });
    }
    catch (error) {
        return { notFound: true };
    }
};
export default ProviderFinderResultsPage;

    async function __Next_Translate__getStaticProps__196135ecf8a__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/study-options/education-provider/results',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__196135ecf8a__ as getStaticProps }
  